import angular from 'angular';

(function() {
  'use strict';

  angular.module('app.kissinvoice').config(routesConfig);

  routesConfig.$inject = ['$stateProvider'];

  /* @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('app.kissinvoice', {
        abstract: true,
        component: 'contentLayout'
      })
      .state('app.kissinvoice.list', {
        url: '/kiss-invoice/list',
        resolve: {
          keepSearchData: keepSearchData
        },
        views: {
          content: {
            component: 'listKissInvoices'
          }
        }
      });
  }

  keepSearchData.$inject = ['$transition$'];
  function keepSearchData($transition$) {
    return $transition$.from().name === 'batch_details' || $transition$.from().name === 'envelope_details';
  }
})();
